import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { MostPopularItemsComponent } from './most-popular-items.component';
import { DebounceClickDirectiveModule } from '../../../directives/debounce-click/debounce-click-directive.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';

@NgModule({
  declarations: [MostPopularItemsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
    DebounceClickDirectiveModule,
    FontAwesomeModule,
    TranslocoLocaleModule
  ],
  exports: [MostPopularItemsComponent]
})
export class MostPopularItemsComponentModule {}
